import React, { createContext, useEffect, useState, useCallback } from 'react';
import { jwtDecode } from 'jwt-decode';
import { authAPI } from '../Api/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState({ _id: '', name: '', email: '' });
    const storedUserId = localStorage.getItem('userId');

    const refreshUser = useCallback(async () => {
        const token = localStorage.getItem('token');

        if (token) {
            try {
                const response = await authAPI.getUserData();
                const userData = response.data;

                setUser({
                    _id: userData._id,
                    name: userData.name,
                    email: userData.email,
                });
            } catch (err) {
                try {
                    const decoded = jwtDecode(token);
                    const id = localStorage.getItem('userId');

                    if (decoded && id) {
                        setUser({
                            _id: id,
                            name: decoded.name || '',
                            email: decoded.email || '',
                        });
                    } else {
                        setUser({ _id: '', name: '', email: '' });
                        localStorage.removeItem('token');
                        localStorage.removeItem('userId');
                    }
                } catch (decodeErr) {
                    setUser({ _id: '', name: '', email: '' });
                    localStorage.removeItem('token');
                    localStorage.removeItem('userId');
                }
            }
        } else {
            setUser({ _id: '', name: '', email: '' });
        }
    }, []);

    useEffect(() => {
        refreshUser();
    }, [refreshUser]);

    return (
        <AuthContext.Provider value={{ user, setUser, storedUserId, refreshUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
